import React, { memo } from "react";
import { Layout, HeaderTitle } from "./MobileHeader.style";
import FW from "../../../../../config/word.json";

function MobileHeader() {
  return (
    <Layout>
      <HeaderTitle>
        <h2>{FW.F_W_LOGIN_T1}</h2>
      </HeaderTitle>
      {/* <HeaderBrand $logo={headerLogo} aria-hidden="true" /> */}
    </Layout>
  );
}

export default memo(MobileHeader);
